// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Cofre_IndexResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /cofre (index).
 */
import type { Cofre_IndexItemRow } from './Cofre_IndexItemRow'
import type { Cofre_PaginationRow } from './Cofre_PaginationRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Cofre_IndexResponseDados {
items: Cofre_IndexItemRow[]
pagination: Cofre_PaginationRow
}

export type Cofre_IndexResponse = ApiResponse<Cofre_IndexResponseDados>;

registerResponseContract('Cofre_IndexResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      id:          { type: 'number',  required: false },
      franquia_id: { type: 'number',  required: false },
      nome:        { type: 'string',  required: false },
      banco:       { type: 'string',  required: false },
      agencia:     { type: 'string',  required: false },
      conta:       { type: 'string',  required: false },
      tipo:        { type: 'string',  required: false },
      saldo_atual: { type: 'number',  required: false },
      observacao:  { type: 'string',  required: false },
      created_at:  { type: 'string',  required: false },
      updated_at:  { type: 'string',  required: false },
    },
  },
  pagination: {
    type: 'object',
    required: true,
    fields: {
      page:        { type: 'number',  required: false },
      per_page:    { type: 'number',  required: false },
      total:       { type: 'number',  required: false },
      total_pages: { type: 'number',  required: false },
    },
  },
})
